import * as types from './types';

const initialState = {
  inited: false,
  ready: false,
  config: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.INIT: {
      const newState = {
        ...state,
        inited: true,
      };
      if (action.payload) {
        newState.config = action.payload;
      }
      return newState;
    }
    case types.READY:
      return {
        ...state,
        ready: true,
      };
    default:
      return state;
  }
}
